import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./useAuth";

export function AdminGuard() {
  const { isAuthenticated, isLoading, isSystemAdmin } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isSystemAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
